/**
 * 登記変更申込用データストア
 *  
 */

 /**
 * ステート定義、デフォルト値
 * @returns
 */
const getDefaultState = () => {
  return {
    // 編集状態(0:入力前, 1:入力中, 2:確定, 3:申込完了)
    editStatus: "0",
    // 選択プランIDリスト
    selectedPlanIdList: [],
    // 登記情報ファイルパス
    registFileInfo: {},
    // 役員情報リスト
    // { no: "", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
    officerList: [],
    officerAppointList: [],
    officerResignList: [],
    officerOthersList: [],
    appointDate: "",
    resignDate: "",
    othersDate: "",

    /** 登記変更詳細情報 */
    // 登記変更詳細情報(入力)
    regChgInfoInput: ""
  };
};

/**
 * ステート
 */
const state = getDefaultState();

/**
 * ゲッター
 */
const getters = {
  getEditStatus(state) {
    return state.editStatus;
  },
  getSelectedPlanIdList(state) {
    return state.selectedPlanIdList;
  },
  getRegistFileInfo(state) {
    return state.registFileInfo;
  },
  getOfficerList(state) {
    return state.officerList;
  },
  getOfficerAppointList(state) {
    return state.officerAppointList;
  },
  getOfficerResignList(state) {
    return state.officerResignList;
  },
  getOfficerOthersList(state) {
    return state.officerOthersList;
  },
  getAppointDate(state) {
    return state.appointDate;
  },
  getResignDate(state) {
    return state.resignDate;
  },
  getOthersDate(state) {
    return state.othersDate;
  },
  getRegChgInfoInput(state) {
    return state.regChgInfoInput;
  },
};

/**
 * ミューテーション
 */
const mutations = {
  editStatus(state, status) {
    state.editStatus = status;
  },
  selectedPlanIdList(state, list) {
    state.selectedPlanIdList = list;
  },
  registFileInfo(state, file) {
    state.registFileInfo = file;
  },
  officerList(state, list) {
    state.officerList = list;
  },
  officerAppointList(state, list) {
    state.officerAppointList = list;
  },
  officerResignList(state, list) {
    state.officerResignList = list;
  },
  officerOthersList(state, list) {
    state.officerOthersList = list;
  },
  appointDate(state, status) {
    state.appointDate = status;
  },
  resignDate(state, status) {
    state.resignDate = status;
  },
  othersDate(state, status) {
    state.othersDate = status;
  },
  regChgInfoInput(state, status) {
    state.regChgInfoInput = status;
  },
  /**
   * state初期化
   * @param {ストア}} state 
   */
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

/**
 * アクション
 */
const actions = {
  setEditStatus(context, info) {
    context.commit("editStatus", info);
  },
  setSelectedPlanIdList(context, info) {
    context.commit("selectedPlanIdList", info);
  },
  setRegistFileInfo(context, info) {
    context.commit("registFileInfo", info);
  },
  setOfficerList(context, info) {
    context.commit("officerList", info);
  },
  setOfficerAppointList(context, info) {
    context.commit("officerAppointList", info);
  },
  setOfficerResignList(context, info) {
    context.commit("officerResignList", info);
  },
  setOfficerOthersList(context, info) {
    context.commit("officerOthersList", info);
  },
  setAppointDate(context, info) {
    context.commit("appointDate", info);
  },
  setResignDate(context, info) {
    context.commit("resignDate", info);
  },
  setOthersDate(context, info) {
    context.commit("othersDate", info);
  },
  setRegChgInfoInput(context, info) {
    context.commit("regChgInfoInput", info);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
